module.exports = __webpack_public_path__ + "static/img/self-operatedbg.aceff67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightsDetails/self-operated/self-operatedbg.png
// module id = X+0n
// module chunks = 64